jQuery(document).ready(function($) {
    // 2025 Sliding Fee Schedule (annual thresholds in USD, per-visit fee)
    var slidingFeeSchedule2025 = [{
            familySize: "1",
            brackets: {
                A: { threshold: 15650.00, fee: 10 },
                B: { threshold: 23475.00, fee: 25 },
                C: { threshold: 27387.50, fee: 40 },
                D: { threshold: 31300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "2",
            brackets: {
                A: { threshold: 21150.00, fee: 10 },
                B: { threshold: 31725.00, fee: 25 },
                C: { threshold: 37012.50, fee: 40 },
                D: { threshold: 42300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "3",
            brackets: {
                A: { threshold: 26650.00, fee: 10 },
                B: { threshold: 39975.00, fee: 25 },
                C: { threshold: 46637.50, fee: 40 },
                D: { threshold: 53300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "4",
            brackets: {
                A: { threshold: 32150.00, fee: 10 },
                B: { threshold: 48225.00, fee: 25 },
                C: { threshold: 56262.50, fee: 40 },
                D: { threshold: 64300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "5",
            brackets: {
                A: { threshold: 37650.00, fee: 10 },
                B: { threshold: 56475.00, fee: 25 },
                C: { threshold: 65887.50, fee: 40 },
                D: { threshold: 75300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "6",
            brackets: {
                A: { threshold: 43150.00, fee: 10 },
                B: { threshold: 64725.00, fee: 25 },
                C: { threshold: 75512.50, fee: 40 },
                D: { threshold: 86300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "7",
            brackets: {
                A: { threshold: 48650.00, fee: 10 },
                B: { threshold: 72975.00, fee: 25 },
                C: { threshold: 85137.50, fee: 40 },
                D: { threshold: 97300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "8",
            brackets: {
                A: { threshold: 54150.00, fee: 10 },
                B: { threshold: 81225.00, fee: 25 },
                C: { threshold: 94762.50, fee: 40 },
                D: { threshold: 108300.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        },
        {
            familySize: "Each Additional Person",
            brackets: {
                A: { threshold: 5500.00, fee: 10 },
                B: { threshold: 8250.00, fee: 25 },
                C: { threshold: 9625.00, fee: 40 },
                D: { threshold: 11000.00, fee: 55 },
                NA: { threshold: Infinity, fee: "100%" }
            }
        }
    ];

    function findBracket(familySize, income) {
        var entry = slidingFeeSchedule2025.find(function(e) {
            return String(e.familySize) === String(familySize);
        });
        if (!entry) return null;
        var keys = ["A", "B", "C", "D", "NA"];
        for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            if (income <= entry.brackets[k].threshold) {
                return { key: k, fee: entry.brackets[k].fee };
            }
        }
        return null;
    }

    function updateFeeDisplay() {
        var fam = $('#household-size').val(),
            inc = parseInt($('#income-range').val(), 10),
            bracket = findBracket(fam, inc) || {},
            category = $('#category-text'),
            visitFee = $('#visit-fee-text'),
            disp = $('#income-display'),
            bar = $('#slider-progress-bar');

        disp.text('$' + inc.toLocaleString());

        // reset badge
        category.removeClass().addClass('badge');
        switch (bracket.key) {
            case 'A':
                category.addClass('bg-success');
                break;
            case 'B':
                category.addClass('bg-primary');
                break;
            case 'C':
                category.addClass('bg-warning text-dark');
                break;
            case 'D':
                category.addClass('bg-danger');
                break;
            case 'NA':
                category.addClass('badge-NA text-white');
                break;
            default:
                category.addClass('bg-secondary');
        }
        category.text(bracket.key || '-');

        if (bracket.fee === "100%") {
            visitFee.text('100% of charges').addClass('text-dark');
        } else {
            visitFee.text('$' + (bracket.fee || 0)).removeClass('text-dark');
        }

        var pct = Math.min((inc / 108300) * 100, 100);
        bar.css('width', pct + '%');
    }

    // wire up
    $('#income-range').on('input', updateFeeDisplay);
    $('#household-size').on('change', updateFeeDisplay);

    // init
    updateFeeDisplay();

});